var _circle, _circle2, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalUploadSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#366B65"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 28C42.3041 28 28 42.3041 28 60C28 77.6959 42.3041 92 60 92C77.6959 92 92 77.6959 92 60C92 42.3041 77.6959 28 60 28ZM75.4839 53.3641L56.5346 72.2396C55.9447 72.8295 55.2074 73.1244 54.47 73.1244C53.7327 73.1244 52.9217 72.8295 52.4055 72.2396L43.0415 62.9493C41.8618 61.7696 41.8618 59.9263 43.0415 58.7465C44.2212 57.5668 46.0645 57.5668 47.2442 58.7465L54.47 65.9723L71.2811 49.1613C72.4608 47.9816 74.3041 47.9816 75.4839 49.1613C76.5899 50.341 76.5899 52.2581 75.4839 53.3641Z",
    fill: "#366B65"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalUploadSuccess);
export default __webpack_public_path__ + "static/media/modal-upload-success.3c8b5916.svg";
export { ForwardRef as ReactComponent };